import React, { useRef, useState, useEffect } from 'react';

/**
 * ScrollIndicator - A wrapper component that adds visual indicators for horizontal scrolling
 * Shows shadows/gradients to indicate scrollable content on mobile devices
 */
function ScrollIndicator({ children, className = '' }) {
  const scrollRef = useRef(null);
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);

  const checkScroll = () => {
    if (!scrollRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    
    // Show left shadow if scrolled from the start
    setShowLeftShadow(scrollLeft > 10);
    
    // Show right shadow if not scrolled to the end
    setShowRightShadow(scrollLeft < scrollWidth - clientWidth - 10);
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [children]);

  return (
    <div className={`relative ${className}`}>
      {/* Left shadow indicator */}
      {showLeftShadow && (
        <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-gray-900/10 to-transparent pointer-events-none z-10" />
      )}
      
      {/* Right shadow indicator */}
      {showRightShadow && (
        <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-gray-900/10 to-transparent pointer-events-none z-10" />
      )}
      
      {/* Scroll hint text - only on mobile */}
      {showRightShadow && (
        <div className="md:hidden absolute right-2 top-2 bg-sky-600 text-white text-xs px-2 py-1 rounded shadow-lg pointer-events-none z-20 animate-pulse">
          Scroll →
        </div>
      )}
      
      <div 
        ref={scrollRef}
        className="overflow-x-auto"
        onScroll={checkScroll}
      >
        {children}
      </div>
    </div>
  );
}

export default ScrollIndicator;

